"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveButtonLabel = resolveButtonLabel;
var LABEL_PREFIX = 'View';
var DEFAULT_MENU_LABEL = 'Menu';

function resolveButtonLabel(fileName, isOnlyFile) {
  var finalFileName = fileName || DEFAULT_MENU_LABEL;
  return [LABEL_PREFIX, finalFileName].join(' ');
}